import React from 'react';
import './styles.scss';
import { useNavigate } from 'react-router-dom';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { toast } from 'react-toastify';
import { ENUM_ROLE, Login as NewLogin } from '@cokitchen/cokitchen-auth';
import { LoginResponse, LoginEnvType } from '@cokitchen/cokitchen-auth/dist/lib/login/types';

import { CS_TEAM_ROLES, getTeamRoles } from 'utils/role-config';
import useRoleContext from 'contexts/role.context';

const authEnvironment = process.env.REACT_APP_AUTH_ENVIRONMENT as LoginEnvType;

const RightLoginSection = () => {
  const navigate = useNavigate();
  const { setRole, setIsMainAdmin } = useRoleContext();

  const handleLoginSuccess = async (res: LoginResponse) => {
    if (res) {
      const role = res.data.role as ENUM_ROLE;
      const isSuperAdminRole = [
        ENUM_ROLE.ADMIN,
        ENUM_ROLE.SUPER_ADMIN,
        ENUM_ROLE.DEVELOPER
      ].includes(role);

      if (isSuperAdminRole) {
        handleAdminLogin(role);
        return;
      }
      const roleConfig = getTeamRoles();
      if (!roleConfig || !Object.keys(roleConfig)?.includes(role)) {
        handleInvalidRole();
        return;
      }

      setRole(role);
      navigate(roleConfig[role].baseRoute);
    }
  };

  const handleAdminLogin = (role: ENUM_ROLE) => {
    localStorage.setItem(STORAGE_KEYS.ADMIN_ROLE, role);
    localStorage.setItem(STORAGE_KEYS.ROLE, ENUM_ROLE.CS_ADMIN);
    setRole(ENUM_ROLE.CS_ADMIN);
    setIsMainAdmin(true);
    navigate(CS_TEAM_ROLES.CUSTOMER_SERVICE_ADMIN.baseRoute);
  };

  const handleInvalidRole = () => {
    localStorage.clear();
    setRole();
    setIsMainAdmin(false);
    navigate(ROUTE_KEYS.LOGIN);
    toast(<ToastMessage type='error' message='Unrecognized login role!' />);
  };

  return (
    <div className='login-container w-full bg-red-9 p-4 md:overflow-auto'>
      <section className='auth-login__card px-8 md:px-16'>
        <NewLogin
          env={authEnvironment}
          onLogin={handleLoginSuccess}
          title='Login to your dashboard'
          forgotPasswordMeta={{
            shouldTrigger: true,
            dashboard: authEnvironment === 'live' ? 'main' : 'staging-main'
          }}
        />
      </section>
    </div>
  );
};

export default RightLoginSection;
